<template>
  <div class="hero-mini-guitar-spec-carousel">
    <vue-carousel
      :data="slides"
      :slide-on-swipe="false"
    />
  </div>
</template>

<script>
import VueCarousel from '@chenfengyuan/vue-carousel'

export default {
  components: {
    VueCarousel
  },
  data () {
    return {
      slides: [
        '<div class="hero mini-guitar-spec-hero1"><div></div></div>',
        '<div class="hero mini-guitar-spec-hero2"><div></div></div>'
      ]
    }
  },
  mounted: function () {
  },
  methods: {
  }
}

</script>

<style lang="scss">
@import "../styles/base/breakpoint.scss";
.hero-mini-guitar-spec-carousel {
  .hero {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 80vw;
    @include breakpoint("medium") {
      min-height: 620px;
    }
  }
  .hero {
    @include breakpoint("medium"){
      background-size: cover;
    }
    background-image: url('../assets/bias-mini-guitar/spec-hero@2x.png');
  }
  .hero > div {
    height: 138px;
    width: 60%;
    margin: 0 auto;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
  .mini-guitar-spec-hero1 > div {
    background-image: url('../assets/bias-mini-guitar/mini-front@2x.png');
  }
  .mini-guitar-spec-hero2 > div {
    background-image: url('../assets/bias-mini-guitar/mini-back@2x.png');
  }
}
.carousel__item--active {
  z-index: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/bias-mini-guitar-spec-carousel.vue